import React, { useCallback } from "react";
import { Typography } from "components";
import { useDropzone } from "react-dropzone";
import uploadSuccess from "assets/images/file-upload-success.png";
import { AiOutlineDelete } from "react-icons/ai";
import { setAlert } from "utils/helper";

const FileUpload = ({
  acceptedFormats,
  acceptedFormatsText,
  required = true,
  label,
  maxSize = 10000000,
  onChange,
  uploadedFile,
  className,
  disabled,
}) => {
  const { getRootProps, getInputProps } = useDropzone({
    accept: acceptedFormats,
    onDrop: useCallback(
      (file) => {
        if (file[0].size > maxSize) {
          //   setAlert(`Maximum file size is ${maxSize.toString()[0]}Mb`);
          setAlert(`Maximum file size is 10Mb`);
        } else {
          onChange(file);
        }
      },
      [maxSize, onChange]
    ),
    multiple: false,
  });

  return (
    <div className={className}>
      <label htmlFor={""} className={"pm-label"}>
        {label}
        {required && (
          <span style={{ marginLeft: ".2rem" }} className="font-danger">
            *
          </span>
        )}
      </label>
      <div {...getRootProps()} className="cursor-pointer">
        {!disabled && <input {...getInputProps()} />}

        {uploadedFile ? (
          <>
            <div className="upload-container">
              <img src={uploadSuccess} alt="" /> &nbsp; &nbsp;
              <Typography variant="body3">{uploadedFile?.name}</Typography>
            </div>
            {uploadedFile && (
              <Typography variant="caption1" onClick={() => onChange("")}>
                Remove this file{" "}
                <AiOutlineDelete
                  className="font-danger"
                  fontSize="13px"
                  style={{ marginTop: "-.2rem" }}
                />
              </Typography>
            )}
          </>
        ) : (
          <>
            <div className="">
              <div className="upload-container">
                <div>
                  {disabled ? (
                    <Typography state="grey" variant="body3">
                      File Uploaded
                    </Typography>
                  ) : (
                    <Typography variant="body3">Upload File</Typography>
                  )}
                </div>
                {!disabled && (
                  <Typography variant="body3">No file Chosen</Typography>
                )}
              </div>
              <div className="d-flex justify-content-between">
                <Typography variant="caption1">Max Size: 10Mb</Typography>
                <Typography variant="caption1">
                  Formats: {acceptedFormatsText}
                </Typography>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default FileUpload;
